import { ComboboxProps } from '@components/app/form/select/downshift/Combobox';
import { ComboboxItem } from '@components/app/form/select/downshift/types';
import ApiCombobox from '@components/app/form/select/downshift/ApiCombobox';
import { Publication } from '@/types/core/Publication';

export type PublicationComboboxProps = Omit<
  ComboboxProps,
  'loadSelectItems'
> & {
  normalizer?: (item: any) => ComboboxItem;
  filters?: Record<string, string>;
  includes?: string[];
  fields?: Record<string, string>;
  orders?: string[];
};

export function publicationComboboxNormalizer(
  publication: Publication
): ComboboxItem {
  const isDraft = publication.state === 'state.draft' ? ' (brouillon)' : '';
  const author = publication.author
    ? publication.author.displayName
    : 'Anonyme';
  const privateGroup =
    publication.group && publication.group.private
      ? ` (Accès restreint : ${publication.group.name})`
      : '';

  return {
    id: publication.id as string,
    label: `${publication.title}${isDraft} (${author})${privateGroup}` as string,
    item: publication,
  };
}

export default function PublicationCombobox({
  placeholder = 'Rechercher une publication',
  includes = ['author', 'group'],
  filters,
  normalizer,
  orders,
  fields = {
    publication: 'title',
    user: 'displayName',
    group: 'name,private',
  },
  ...otherProps
}: PublicationComboboxProps) {
  return (
    <>
      <ApiCombobox
        placeholder={placeholder}
        url={'/api/publications'}
        orders={orders}
        includes={includes}
        filters={filters}
        fields={fields}
        normalizer={normalizer ? normalizer : publicationComboboxNormalizer}
        apiClient={fetch}
        {...otherProps}
      />
    </>
  );
}
